<!-- Summary tiles -->
<div class="ch-sk-tiles" *ngIf="variant === 'tiles'">
  <div class="ch-sk-tile" *ngFor="let t of tileArray">
    <span class="ch-sk ch-sk-num"></span>
    <span class="ch-sk ch-sk-label"></span>
  </div>
</div>

<!-- Table -->
<div class="ch-sk-table" *ngIf="variant === 'table'">
  <div class="ch-sk-thead">
    <span class="ch-sk ch-sk-th" *ngFor="let c of colArray"></span>
  </div>
  <div class="ch-sk-trow" *ngFor="let r of rowArray">
    <span class="ch-sk ch-sk-td" *ngFor="let c of colArray"></span>
  </div>
</div>

<!-- Chart / donut -->
<div class="ch-sk-chart" *ngIf="variant === 'chart'">
  <span class="ch-sk ch-sk-title"></span>
  <div class="ch-sk-donut"></div>
  <div class="ch-sk-legend">
    <span class="ch-sk ch-sk-line" *ngFor="let r of legendArray"></span>
  </div>
</div>

<!-- Cards -->
<div class="ch-sk-cards" *ngIf="variant === 'cards'">
  <span class="ch-sk ch-sk-card" *ngFor="let r of rowArray"></span>
</div>

<!-- Lines -->
<div class="ch-sk-lines" *ngIf="variant === 'lines'">
  <span class="ch-sk ch-sk-line" *ngFor="let r of rowArray"></span>
</div>

<!-- Form fields -->
<div class="ch-sk-form" *ngIf="variant === 'form'">
  <div class="ch-sk-field" *ngFor="let r of rowArray">
    <span class="ch-sk ch-sk-flabel"></span>
    <span class="ch-sk ch-sk-finput"></span>
  </div>
</div>
